<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="565">
      <div @click="close" class="close">
        <Icon name="close" />
      </div>
      <v-card class="wrapper">
        <div class="modal_title" v-if="isEditing">Редактировать обзвон</div>
        <div class="modal_title" v-else>Новый обзвон</div>
        <div>
          <p class="modal_subtitle">Введите название</p>
          <v-text-field
            height="40"
            placeholder="Тестовый обзвон"
            v-model="data_local.name"
            :rules="rules"
          ></v-text-field>
        </div>

        <div>
          <p class="modal_subtitle">Выберите базу контактов</p>
          <v-autocomplete
            :disabled="isCallMade"
            class="mih40"
            height="40"
            hide-details
            item-color="#fee600"
            :items="bases"
            item-value="id"
            v-model="data_local.select_base"
            item-text="name"
            solo
            clearable
            :search-input.sync="searchBase"
            :filter="filterItems"
            placeholder="Введите базу контактов"
            no-data-text="Ничего не найдено"
          ></v-autocomplete>
          <div class="add_new">
            <router-link class="add_new" :to="'/bases'"
              >Добавить новую базу контактов</router-link
            >
          </div>
        </div>

        <div>
          <p class="modal_subtitle">Выберите сценарий звонка</p>
          <v-autocomplete
            :disabled="isCallMade"
            height="40"
            class="mih40"
            hide-details
            @change="extractTargets"
            item-color="#fee600"
            color="#4B5EFF"
            :items="scenaries"
            item-value="id"
            v-model="data_local.select_scenario"
            item-text="name"
            solo
            clearable
            :search-input.sync="searchScenario"
            :filter="filterItems"
            placeholder="Введите сценарий звонка"
            no-data-text="Ничего не найдено"
          ></v-autocomplete>
          <div class="add_new">
            <router-link class="add_new" :to="'/scripts'"
              >Добавить новый сценарий звонка</router-link
            >
          </div>
        </div>
        <div class="heading">Исходящие номера</div>
        <v-radio-group v-model="data_local.outbound_mode" class="mih40">
          <v-radio
            :disabled="!hasActiveCarousels"
            label="Все активные карусели"
            value="all_active"
            color="#4B5EFF"
          />
          <v-radio
            :disabled="!hasActiveCarousels"
            label="Выбрать карусели"
            value="carousels"
            color="#4B5EFF"
          />
        </v-radio-group>

        <div v-if="data_local.outbound_mode === 'carousels'">
          <v-autocomplete
            class="mih40 multi-wrap"
            hide-details="auto"
            :lazy-rules="true"
            multiple
            clearable
            item-color="#fee600"
            :items="activeCarousels"
            item-value="id"
            item-text="name"
            v-model="data_local.outbound_carousels"
            :rules="carouselsRules"
            solo
            placeholder="Выберите карусели (только Активна)"
            no-data-text="Нет активных каруселей"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index < 5"
                small
                label
                class="chip-truncate"
                close
                @click:close="
                  data_local.outbound_carousels =
                    data_local.outbound_carousels.filter((id) => id !== item.id)
                "
              >
                {{ item.name }}
              </v-chip>
              <span
                v-else-if="index === 5"
                class="ml-2 grey--text text--darken-1 caption"
              >
                + ещё {{ data_local.outbound_carousels.length - 5 }}
              </span>
            </template>

            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-bind="attrs" v-on="on" color="#4B5EFF">
                <v-list-item-content>
                  <v-list-item-title class="truncate-line">{{
                    item.name
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>

          <div class="add_new" v-if="!hasActiveCarousels">
            Нет активных каруселей, перейдите в раздел
            <router-link to="/numbers">«Номера»</router-link>
            для выделения активной карусели.
          </div>
        </div>

        <div class="select_type" v-if="!guid">
          <div class="titler">Выберите тип обзвона</div>
          <v-radio-group v-model="data_local.currentType">
            <v-tooltip
              top
              max-width="300"
              color="#696969"
              v-for="n in type"
              :key="n.value"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="tooltip">
                  <v-radio :label="n.name" :value="n.value" color="#4B5EFF">
                  </v-radio>
                  <span class="question" v-bind="attrs" v-on="on">
                    <Icon name="question" />
                  </span>
                </div>
              </template>

              <span> {{ n.tooltip }}</span>
            </v-tooltip>
          </v-radio-group>
        </div>

        <v-expansion-panels>
          <v-expansion-panel class="my_expand_panel">
            <v-expansion-panel-header
              >Расширенные настройки</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <div class="pt-4 region-head">
                <v-checkbox
                  v-model="regions_enabled"
                  label="Настроить регионы"
                  color="#4B5EFF"
                />
                <div class="regions-btn">
                  <v-btn
                    icon
                    small
                    :disabled="!regions_enabled"
                    @click.stop="toggleRegionsOpen"
                    :title="
                      regions_open ? 'Скрыть регионы' : 'Показать регионы'
                    "
                  >
                    <v-icon size="32">
                      {{
                        regions_open ? 'mdi-chevron-up' : 'mdi-chevron-down'
                      }}</v-icon
                    >
                  </v-btn>
                </div>
              </div>
              <v-expand-transition>
                <div v-show="regions_enabled && regions_open">
                  <v-checkbox
                    @click.stop
                    label="Выбрать всё"
                    color="#4B5EFF"
                    :input-value="allRegionsSelected"
                    :indeterminate="someRegionsSelected && !allRegionsSelected"
                    @change="toggleSelectAllRegions"
                  />
                  <div class="heading">Регионы</div>
                  <v-combobox
                    class="p2"
                    v-model="data_local.regions_selected"
                    :menu-props="{ top: true, offsetY: true }"
                    :items="regions"
                    multiple
                    chips
                    deletable-chips
                    hide-details
                    item-color="#4B5EFF"
                    @copy.native="copyRegions"
                    @paste.native="pasteRegions"
                  >
                  </v-combobox>
                </div>
              </v-expand-transition>

              <div class="pt-4 region-head">
                <v-checkbox
                  v-model="operators_enabled"
                  label="Настроить операторов"
                  color="#4B5EFF"
                />
                <div class="regions-btn">
                  <v-btn
                    icon
                    small
                    :disabled="!operators_enabled"
                    @click.stop="toggleOperatorsOpen"
                    :title="
                      operators_open
                        ? 'Скрыть операторов'
                        : 'Показать операторов'
                    "
                  >
                    <v-icon size="32">
                      {{
                        operators_open ? 'mdi-chevron-up' : 'mdi-chevron-down'
                      }}</v-icon
                    >
                  </v-btn>
                </div>
              </div>
              <v-expand-transition>
                <div v-show="operators_enabled && operators_open">
                  <v-checkbox
                    @click.stop
                    label="Выбрать всё"
                    color="#4B5EFF"
                    :input-value="allOperatorsSelected"
                    :indeterminate="
                      someOperatorsSelected && !allOperatorsSelected
                    "
                    @change="toggleSelectAllOperators"
                  />
                  <div class="heading">Операторы</div>
                  <v-combobox
                    class="p2"
                    v-model="data_local.operators_selected"
                    :menu-props="{ top: true, offsetY: true }"
                    :items="operators"
                    multiple
                    chips
                    deletable-chips
                    hide-details
                    item-color="#4B5EFF"
                    @copy.native="copyOperators"
                    @paste.native="pasteOperators"
                  >
                  </v-combobox>
                </div>
              </v-expand-transition>

              <div class="heading">Дата и время отложенного запуска</div>
              <div class="date_time">
                <div class="input_wrap">
                  <v-menu
                    v-model="data_local.menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="rel" v-bind="attrs" v-on="on">
                        <v-text-field
                          v-model="data_local.date"
                          readonly
                          height="32"
                          hide-details
                          class="input_datetime"
                        />
                        <div @click="clearDateTimeDefer('date')">
                          <Icon
                            v-on="on"
                            v-if="data_local.date"
                            class="close-date-picker"
                            name="close"
                          />
                        </div>
                        <Icon
                          v-if="!data_local.date"
                          class="abs"
                          name="calendar"
                        />
                      </div>
                    </template>
                    <v-date-picker
                      v-model="data_local.date"
                      @input="data_local.menu1 = false"
                      locale="ru"
                      color="#4B5EFF"
                      event-color="#000"
                      class="m-w-200p"
                      no-title
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="input_wrapper">
                  <v-menu
                    ref="menu"
                    v-model="data_local.menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="rel">
                        <v-text-field
                          v-model="data_local.time"
                          readonly
                          height="32"
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                          class="input_datetime w-80p"
                        />
                        <div @click="clearDateTimeDefer('time')">
                          <Icon
                            v-if="data_local.time"
                            class="close-date-picker"
                            name="close"
                          />
                        </div>
                      </div>
                    </template>
                    <v-time-picker
                      v-if="data_local.menu2"
                      v-model="data_local.time"
                      format="24hr"
                      color="#4B5EFF"
                      @click:minute="$refs.menu.save(date_local.time)"
                    ></v-time-picker>
                  </v-menu>
                </div>
              </div>

              <div class="row_wrapper">
                <div class="heading">
                  Добавить действия с номерами которым не получилось дозвонится
                </div>
                <div class="plus" @click="addOptionsNoCall()">
                  <Icon name="plus" />
                </div>
              </div>
              <div
                v-for="(option, key) in data_local.options_no_call"
                :key="key"
              >
                <div class="row_wrapper">
                  <v-select
                    class="mih40"
                    height="40"
                    hide-details
                    item-color="#4B5EFF"
                    :items="list_action"
                    item-value="id"
                    v-model="option.id"
                    item-text="name"
                    solo
                    placeholder="Выберите действие"
                    @change="changeOption(key)"
                  ></v-select>
                  <div
                    class="minus mr-0 ml-2"
                    @click="deleteOptionsNoCall(key)"
                  >
                    <Icon name="minus" />
                  </div>
                </div>
                <div class="" v-if="option.id === list_action[1].id">
                  <div class="heading">Укажите параметры интеграции</div>
                  <v-text-field
                    height="40"
                    placeholder="id"
                    v-model="option.options"
                  ></v-text-field>
                </div>
              </div>

              <div class="heading">
                Попытки дозвониться
                <v-tooltip top max-width="300" color="#696969">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="question" v-bind="attrs" v-on="on">
                      <Icon name="question" />
                    </span>
                  </template>
                  <span
                    >Предельное количество попыток дозвониться. Минимальное
                    значение - 1, максимальное - 4.</span
                  >
                </v-tooltip>
              </div>

              <div class="input_wrapper">
                <div
                  class="minus"
                  @click="decrementCallAttempts"
                  :disabled="tryCallsDisplay <= 1"
                >
                  <Icon name="minus" />
                </div>
                <v-text-field
                  class="mini_input"
                  :value="tryCallsDisplay"
                  readonly
                  hide-details
                ></v-text-field>
                <div
                  class="plus"
                  @click="incrementCallAttempts"
                  :disabled="tryCallsDisplay >= 4"
                >
                  <Icon name="plus" />
                </div>
              </div>
              <div class="heading">Через сколько минут перезванивать</div>
              <div class="input_wrapper">
                <div class="minus" @click="data_local.delay_call--">
                  <Icon name="minus" />
                </div>
                <v-text-field
                  type="number"
                  height="32"
                  class="mini_input"
                  min="0"
                  v-model="data_local.delay_call"
                ></v-text-field>
                <div class="plus" @click="data_local.delay_call++">
                  <Icon name="plus" />
                </div>
              </div>

              <div class="heading">
                <v-checkbox
                  label="Использовать количество линий"
                  color="#4B5EFF"
                  v-model="data_local.use_lines_count"
                ></v-checkbox>
              </div>
              <div v-if="data_local.use_lines_count">
                <div class="heading">
                  Количество линий
                  <v-tooltip top max-width="300" color="#696969">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="question" v-bind="attrs" v-on="on">
                        <Icon name="question" />
                      </span>
                    </template>
                    <span
                      >Количество одновременных линий для обзвона. Минимум 1,
                      максимум 1000.</span
                    >
                  </v-tooltip>
                </div>

                <div class="input_wrapper">
                  <div class="minus" @click="decrementLinesCount">
                    <Icon name="minus" />
                  </div>
                  <v-text-field
                    type="number"
                    height="32"
                    class="mini_input"
                    :min="1"
                    :max="1000"
                    v-model.number="data_local.lines_count"
                    hide-details
                    @blur="validateLinesCount"
                    @change="validateLinesCount"
                  ></v-text-field>
                  <div class="plus" @click="incrementLinesCount">
                    <Icon name="plus" />
                  </div>
                </div>
              </div>
              <div class="heading">
                <v-checkbox
                  label="Черный список по всем моим базам"
                  color="#4B5EFF"
                  v-model="data_local.all_blacklist"
                ></v-checkbox>
              </div>
              <div class="heading">
                <v-checkbox
                  label="Остановить по достижению цели"
                  color="#4B5EFF"
                  v-model="data_local.target_on"
                ></v-checkbox>
              </div>
              <div v-if="data_local.target_on">
                <v-select
                  class="mih40"
                  height="40"
                  v-model="data_local.target_name"
                  :items="targets"
                  item-color="#4B5EFF"
                  solo
                ></v-select>

                <div class="input_wrapper">
                  <div class="minus" @click="data_local.limit--">
                    <Icon name="minus" />
                  </div>
                  <v-text-field
                    height="32"
                    class="mini_input"
                    min="0"
                    v-model="data_local.limit"
                  ></v-text-field>
                  <div class="plus" @click="data_local.limit++">
                    <Icon name="plus" />
                  </div>
                </div>
              </div>

              <v-checkbox
                label="Использовать часовой пояс клиента"
                color="#4B5EFF"
                v-model="data_local.is_client_gtm"
              ></v-checkbox>
              <div class="heading">Учитывать время клиента</div>

              <div v-if="!data_local.is_client_gtm">
                <v-select
                  class="mih40"
                  height="40"
                  hide-details
                  item-color="#4B5EFF"
                  :items="listTimezoneRu"
                  item-value="gtm"
                  v-model="data_local.client_gtm"
                  item-text="name"
                  solo
                />
              </div>

              <div>
                <v-range-slider
                  v-model="data_local.range"
                  :max="24"
                  :min="0"
                  hide-details
                  track-fill-color="#4B5EFF"
                  thumb-color="#4B5EFF"
                  track-color="#AAABAD"
                  color="#4B5EFF"
                  class="align-center"
                >
                  <template v-slot:prepend>
                    <v-text-field
                      v-model="data_local.range[0]"
                      class="mt-0 pt-0 mini_input"
                      hide-details
                      single-line
                      type="number"
                      style="width: 40px; height: 40px"
                    ></v-text-field>
                  </template>
                  <template v-slot:append>
                    <v-text-field
                      v-model="data_local.range[1]"
                      class="mt-0 pt-0 mini_input"
                      hide-details
                      single-line
                      type="number"
                      style="width: 40px; height: 40px; padding: 4px"
                    ></v-text-field>
                  </template>
                </v-range-slider>
              </div>
              <div class="heading">
                <v-checkbox
                  v-if="!isEditing || data_local.send_call_webhook"
                  label="Отправить WebHook по результату звонка"
                  color="#4B5EFF"
                  v-model="data_local.send_call_webhook"
                ></v-checkbox>
              </div>
              <div
                v-if="
                  (!isEditing || data_local.send_call_webhook) &&
                  data_local.send_call_webhook
                "
              >
                <div class="heading">Метод запроса</div>
                <v-select
                  class="mih40"
                  height="40"
                  hide-details
                  item-color="#4B5EFF"
                  :items="['GET', 'POST']"
                  v-model="data_local.call_webhook_method"
                  solo
                ></v-select>

                <template v-if="data_local.call_webhook_method === 'GET'">
                  <div class="heading">Postback URL</div>
                  <v-textarea
                    auto-grow
                    rows="3"
                    placeholder="https://site.ru/webhook?phone={phoneB}&code={4num_code}&status={status}"
                    v-model="data_local.call_webhook_url"
                  ></v-textarea>
                  <div class="paste" @click="pasteGet('phone', 'phoneB')">
                    phone
                  </div>
                  <div class="paste" @click="pasteGet('code', '4num_code')">
                    code
                  </div>
                </template>

                <template v-else>
                  <div class="heading">URL для POST-запроса</div>
                  <v-text-field
                    height="40"
                    placeholder="https://site.ru/webhook"
                    v-model="data_local.call_webhook_url"
                  ></v-text-field>

                  <div class="heading">Тело запроса (JSON)</div>
                  <v-textarea
                    auto-grow
                    rows="4"
                    placeholder='{"phone":"{phoneB}", "code": "{4num_code}"'
                    v-model="data_local.call_webhook_body"
                  ></v-textarea>
                </template>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div
          class="add btn_save"
          v-if="isEditing"
          @click="save(false)"
          :disabled="saving"
        >
          {{ saving ? 'Сохраняем...' : 'Сохранить' }}
        </div>

        <!-- Если isEditing === false (создание) -->
        <div v-else class="actions_create">
          <button
            class="add_sec btn_with_loader"
            @click="save('wait')"
            :disabled="disabledSave || saving"
          >
            <span :class="{ invisible_text: saving }"
              >Добавить и запустить</span
            >
            <v-progress-circular
              v-if="saving"
              indeterminate
              size="18"
              width="2"
              color="white"
              class="btn_spinner"
            />
          </button>
          <button
            class="cancel cancel_btn btn_with_loader cancel_loader"
            @click="save('stop')"
            :disabled="saving"
          >
            <span :class="{ invisible_text: saving }"
              >Добавить без запуска</span
            >
            <v-progress-circular
              v-if="saving"
              indeterminate
              size="18"
              width="2"
              color="currentColor"
              class="btn_spinner"
            />
          </button>
        </div>
        <div v-if="carouselError" class="carousel_error">
          {{ carouselErrorMessage }}
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Icon from '../../SetIcon.vue';

export default {
  components: {
    Icon,
  },
  props: ['name', 'callback_refresh', 'show_dialog', 'data', 'guid'],
  watch: {
    'data_local.outbound_carousels'(val) {
      if (Array.isArray(val) && val.length > 0) this.carouselError = false;
    },
    'data_local.outbound_mode'(val, oldVal) {
      this.carouselError = false;
      if (this.carousel_init_lock) return;
      //  if (val === 'standard') {
      //    this.data_local.outbound_carousels = []
      //  }
      if (val === 'all_active') {
        this.data_local.outbound_carousels = this.activeCarousels.map(
          (c) => c.id,
        );
      }
      if (val === 'carousels') {
        if (oldVal === 'all_active') {
          this.data_local.outbound_carousels = [];
        }
      }
    },
    regions_enabled(val) {
      if (this.regions_init_lock) return;

      if (val) {
        if (
          !Array.isArray(this.data_local.regions_selected) ||
          this.data_local.regions_selected.length === 0
        ) {
          this.data_local.regions_selected = [...this.regions];
        }
      } else {
        this.data_local.regions_selected = [];
      }
    },
    operators_enabled(val) {
      if (this.operators_init_lock) return;

      if (val) {
        if (
          !Array.isArray(this.data_local.operators_selected) ||
          this.data_local.operators_selected.length === 0
        ) {
          this.data_local.operators_selected = [...this.operators];
        }
      } else {
        this.data_local.operators_selected = [];
      }
    },
    show_dialog: function (val) {
      this.dialog = val;
      if (this.data) {
        this.carousel_init_lock = true; // <-- НОВОЕ: блокируем watcher
        this.data_local = JSON.parse(JSON.stringify(this.data));
        if (typeof this.data_local.send_call_webhook !== 'boolean')
          this.data_local.send_call_webhook = false;
        if (!this.data_local.call_webhook_method)
          this.data_local.call_webhook_method = 'POST';
        if (!this.data_local.call_webhook_url)
          this.data_local.call_webhook_url = '';
        if (!this.data_local.call_webhook_body)
          this.data_local.call_webhook_body = '';
        this.regions_init_lock = true;
        this.regions_enabled =
          Array.isArray(this.data_local.regions_selected) &&
          this.data_local.regions_selected.length > 0;
        this.operators_init_lock = true;
        this.operators_enabled =
          Array.isArray(this.data_local.operators_selected) &&
          this.data_local.operators_selected.length > 0;
        this.$nextTick(() => {
          this.regions_init_lock = false;
          this.operators_init_lock = false;
          this.carousel_init_lock = false; // <-- НОВОЕ: разблокируем после рендера
        });
        this.isCallMade = this.data.call > 0;
        if (
          !this.data_local.outbound_mode ||
          this.data_local.outbound_mode === 'standard'
        )
          this.data_local.outbound_mode = 'all_active';
        if (!Array.isArray(this.data_local.outbound_carousels))
          this.data_local.outbound_carousels = [];
        this.listActiveCarousels(true);
        if (this.data.is_client_gtm === false)
          this.data_local.is_client_gtm = false;
        else if (
          this.data.is_client_gtm &&
          this.data_local.is_client_gtm === true
        )
          this.data_local.is_client_gtm = true;
        else this.data_local.is_client_gtm = true;
        this.extractTargets();

        // console.log(this.data_local.options_no_call, '++++++++++++++++++++++++++++++++++++++')
      } else {
        this.carousel_init_lock = false;
        this.data_local = {
          name: null,
          menu1: false,
          range: [9, 18],
          target_on: false,
          all_blacklist: false,
          target_name: '',
          limit: 0,
          target: 0,
          menu2: false,
          operators_selected: [],
          regions_selected: [],
          select_base: null,
          try_calls: 0,
          time: null,
          date: null,
          delay_call: 10,
          select_trigger: 'add',
          select_scenario: null,
          currentType: 'standart',
          options_no_call: [],
          select_number: null,
          is_client_gtm: true, // Признак использования часового пояса клиента
          client_gtm: this.getTimeZone(),
          outbound_mode: 'all_active',
          outbound_carousels: [],
          carouselErrorMessage: '',
          send_call_webhook: false,
          call_webhook_method: 'POST',
          call_webhook_body: '',
          call_webhook_url: '',
          lines_count: 1,
          use_lines_count: false,
        };
        this.saving = false;
        this.disabledSave = false;
        this.carouselError = false;
        this.listActiveCarousels(false);
      }
    },
    dialog(val) {
      if (!val && this.show_dialog) {
        this.close();
      }
    },
    'data_local.target_on'(newVal) {
      if (!newVal) {
        this.data_local.limit = 0;

        this.data_local.target_name = '';
      }
    },
  },
  methods: {
    incrementLinesCount() {
      if (this.data_local.lines_count < 1000) {
        this.data_local.lines_count++;
      }
    },
    decrementLinesCount() {
      if (this.data_local.lines_count > 1) {
        this.data_local.lines_count--;
      }
    },
    validateLinesCount() {
      if (!this.data_local.lines_count || this.data_local.lines_count < 1) {
        this.data_local.lines_count = 1;
      } else if (this.data_local.lines_count > 1000) {
        this.data_local.lines_count = 1000;
      } else {
        this.data_local.lines_count = Math.floor(this.data_local.lines_count);
      }
    },
    pasteGet(key, field) {
      const hasQuery = this.data_local.call_webhook_url.includes('?');
      const separator = hasQuery ? '&' : '?';

      this.data_local.call_webhook_url += `${separator}${key}={${field}}`;
    },
    toggleRegionsOpen() {
      if (!this.regions_enabled) return;
      this.regions_open = !this.regions_open;
    },
    toggleSelectAllRegions() {
      if (this.allRegionsSelected) {
        this.data_local.regions_selected = [];
      } else {
        this.data_local.regions_selected = [...this.regions];
      }
    },
    toggleOperatorsOpen() {
      if (!this.operators_enabled) return;
      this.operators_open = !this.operators_open;
    },
    toggleSelectAllOperators() {
      if (this.allOperatorsSelected) {
        this.data_local.operators_selected = [];
      } else {
        this.data_local.operators_selected = [...this.operators];
      }
    },
    listActiveCarousels(isEditing) {
      this.$http.post(
        '/numbers/carousel',
        { status: 'active', offset: 0, limit: 200, lite: true },
        (res) => {
          const items = Array.isArray(res) ? res : [];
          this.activeCarousels = items.map((x) => ({
            id: x.id,
            name: x.carousel,
          }));
          this.hasActiveCarousels = this.activeCarousels.length > 0;

          if (!isEditing) {
            this.data_local.outbound_mode = this.hasActiveCarousels
              ? 'all_active'
              : 'all_active';
          } else {
            if (!this.hasActiveCarousels) {
              this.data_local.outbound_mode = 'all_active';
              this.data_local.outbound_carousels = [];
            } else if (this.data_local.outbound_mode === 'carousels') {
              const activeIds = new Set(this.activeCarousels.map((c) => c.id));
              const filtered = (
                this.data_local.outbound_carousels || []
              ).filter((id) => activeIds.has(id));
              this.data_local.outbound_carousels = filtered;
              if (!filtered.length) {
                this.data_local.outbound_mode = 'all_active';
                this.data_local.outbound_carousels = this.activeCarousels.map(
                  (c) => c.id,
                );
              }
            }
          }

          if (this.data_local.outbound_mode === 'all_active') {
            this.data_local.outbound_carousels = this.activeCarousels.map(
              (c) => c.id,
            );
          }
        },
      );
    },
    incrementCallAttempts() {
      if (this.tryCallsDisplay < 4) {
        this.data_local.try_calls++;
      }
    },
    decrementCallAttempts() {
      if (this.tryCallsDisplay > 1) {
        this.data_local.try_calls--;
      }
    },
    /**
     * Очистка полей даты и времени отложенного запуска
     * @function clearDateTimeDefer
     * @param {String} typeInput - Тип поля date или time
     */
    clearDateTimeDefer(typeInput) {
      alert(1);
      if (typeInput === 'date') this.data_local.date = null;
      if (typeInput === 'time') this.data_local.time = null;
    },

    /**
     * Получение временной зоны
     * Пример возврата для Московского времени: 3
     * @function getTimeZone
     * @return {Number} Временная зона
     */
    getTimeZone() {
      const offset = new Date().getTimezoneOffset(),
        o = Math.abs(offset);
      return +((offset < 0 ? '' : '-') + ('00' + Math.floor(o / 60)).slice(-1));
    },
    extractTargets() {
      this.targets = [];
      this.scenaries.forEach((item) => {
        if (item.id == this.data_local.select_scenario) {
          if (item.data) {
            let data = JSON.parse(item.data);
            for (let key in data) {
              if (data[key].type == 'target') {
                this.targets.push(data[key].data.name);
              }
            }
          }
        }
      });
    },
    close(render = false, errored = false, error_message = '') {
      this.dialog = false;
      this.saving = false;
      this.disabledSave = false;

      this.data_local = {};
      this.callback_refresh(render, errored, error_message);
    },
    save(status = false) {
      if (this.saving) return;
      this.saving = true;
      this.disabledSave = true;
      if (
        this.operators_enabled &&
        (!Array.isArray(this.data_local.operators_selected) ||
          this.data_local.operators_selected.length === 0)
      ) {
        this.saving = false;
        this.disabledSave = false;
        this.carouselError = true;
        this.carouselErrorMessage = 'Выберите хотя бы одного оператора';
        return;
      }
      if (!this.hasActiveCarousels) {
        this.saving = false;
        this.disabledSave = false;
        this.carouselError = true;
        this.carouselErrorMessage =
          'Нет активных каруселей, перейдите в раздел «Номера» для выделения активной карусели';
        return;
      }
      const linesCount = Number(this.data_local.lines_count) || 1;
      if (linesCount < 1 || linesCount > 1000) {
        this.saving = false;
        this.disabledSave = false;
        this.carouselError = true;
        this.carouselErrorMessage = 'Количество линий должно быть от 1 до 1000';
        return;
      }
      this.data_local.lines_count = linesCount;
      this.data_local.name = this.data_local.name?.trim() || '';
      if (
        this.data_local.name &&
        this.data_local.select_base &&
        this.data_local.select_scenario
      ) {
        if (
          this.data_local.outbound_mode === 'carousels' &&
          (!Array.isArray(this.data_local.outbound_carousels) ||
            this.data_local.outbound_carousels.length === 0)
        ) {
          this.saving = false;
          this.disabledSave = false;
          this.carouselError = true;
          // alert('Выберите хотя бы одну активную карусель для исходящих номеров')
          return;
        }
        if (
          !this.data_local.outbound_mode ||
          this.data_local.outbound_mode === 'standard'
        ) {
          this.data_local.outbound_mode = 'all_active';
        }
        if (!Array.isArray(this.data_local.outbound_carousels))
          this.data_local.outbound_carousels = [];
        if (this.data_local.outbound_mode === 'all_active') {
          this.data_local.outbound_carousels = this.activeCarousels.map(
            (c) => c.id,
          );
        }
        if (this.data_local.send_call_webhook) {
          this.data_local.call_webhook_url = (
            this.data_local.call_webhook_url || ''
          ).trim();
          this.data_local.call_webhook_body = (
            this.data_local.call_webhook_body || ''
          ).trim();

          if (!this.data_local.call_webhook_url) {
            this.saving = false;
            this.disabledSave = false;
            return;
          }
          if (
            this.data_local.call_webhook_method === 'POST' &&
            !this.data_local.call_webhook_body
          ) {
            this.saving = false;
            this.disabledSave = false;
            return;
          }
          if (this.data_local.call_webhook_method === 'POST') {
            try {
              JSON.parse(this.data_local.call_webhook_body);
            } catch (e) {
              this.saving = false;
              this.disabledSave = false;
              this.carouselError = true;
              this.carouselErrorMessage =
                'Тело POST запроса должно быть валидным JSON';
              return;
            }
          }
        }

        if (status) {
          this.data_local.status = status;
        }

        if (!this.isEditing) {
          this.data_local.contacts = 0;
          this.data_local.call = 0;
        }
        delete this.data_local['created_at'];
        this.data_local.try_calls = this.tryCallsDisplay - 1;
        this.$http.post(
          '/call/add',
          {
            id: this.guid,
            data: this.data_local,
          },
          (data) => {
            this.saving = false;
            this.close(true, data.errored, data.error_message);
          },
        );

        // this.close(true);
      }
    },
    listDicts() {
      let _this = this;
      this.bases.length = 0;
      this.$http.post('/base/dicts', {}, (data) => {
        _this.operators = data.operators;
        _this.regions = data.regions;
      });
    },
    listScripts() {
      let _this = this;
      this.bases.length = 0;
      this.$http.post('/script/list', {}, (data) => {
        if (data)
          data.forEach((item) => {
            _this.scenaries.push({
              id: item.guid,
              name: item.name,
              data: item.data,
            });
          });
        _this.extractTargets();
      });
    },
    listBases() {
      let _this = this;
      this.bases.length = 0;
      this.$http.post('/base/shortlist', {}, (data) => {
        if (data)
          data.forEach((item) => {
            _this.bases.push({ id: item.guid, name: item.name });
          });
      });
    },
    listNumbers() {
      let _this = this;
      this.$http.post('/numbers/get_user_numbers', {}, (data) => {
        let numberValueReduced = (phone) => {
          return phone.replace(
            /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/,
            '+$1 ($2) $3-$4-$5',
          );
        };
        this.numbers.push({ clear: null, number: 'Мой случайный номер' });
        if (data && data.data && data.data.length)
          data.data.forEach((item) => {
            _this.numbers.push({
              clear: item.phone,
              number: numberValueReduced(item.phone),
            });
          });
      });
    },
    addOptionsNoCall() {
      // console.log(this.data_local.options_no_call)
      // console.log('=======================')
      if (
        this.data_local.options_no_call.length === 0 ||
        this.data_local.options_no_call[
          this.data_local.options_no_call.length - 1
        ].name_option !== ''
      ) {
        this.data_local.options_no_call.push({
          name_option: 'Выберите действие',
          options: '',
        });
      }
    },
    deleteOptionsNoCall(id) {
      this.data_local.options_no_call.splice(id, 1);
    },
    changeOption(key) {
      if (this.data_local.options_no_call[key].id !== 1) {
        delete this.data_local.options_no_call[key].options;
        delete this.data_local.options_no_call[key].name_option;
      }
    },
    copyOperators(event) {
      const selected = Array.isArray(this.data_local.operators_selected)
        ? this.data_local.operators_selected
        : [];

      event.clipboardData.setData('text/plain', JSON.stringify(selected));
      event.preventDefault();
    },

    pasteOperators(event) {
      event.preventDefault();

      try {
        const text = event.clipboardData.getData('text/plain');
        const pasted = JSON.parse(text);

        if (!Array.isArray(pasted)) return;

        const allowedOperators = pasted.filter((operator) =>
          this.operators.includes(operator),
        );

        this.data_local.operators_selected = [...new Set(allowedOperators)];
      } catch (error) {
        return;
      }
    },
    copyRegions(event) {
      const selected = Array.isArray(this.data_local.regions_selected)
        ? this.data_local.regions_selected
        : [];

      event.clipboardData.setData('text/plain', JSON.stringify(selected));
      event.preventDefault();
    },

    pasteRegions(event) {
      event.preventDefault();

      try {
        const text = event.clipboardData.getData('text/plain');
        const pasted = JSON.parse(text);

        if (!Array.isArray(pasted)) return;

        const allowedRegions = pasted.filter((region) =>
          this.regions.includes(region),
        );

        this.data_local.regions_selected = [...new Set(allowedRegions)];
      } catch {
        return;
      }
    },
  },
  computed: {
    allRegionsSelected() {
      return (
        Array.isArray(this.data_local.regions_selected) &&
        this.data_local.regions_selected.length === this.regions.length
      );
    },
    someRegionsSelected() {
      const n = Array.isArray(this.data_local.regions_selected)
        ? this.data_local.regions_selected.length
        : 0;
      return n > 0 && n < this.regions.length;
    },
    allOperatorsSelected() {
      return (
        Array.isArray(this.data_local.operators_selected) &&
        this.data_local.operators_selected.length === this.operators.length
      );
    },
    someOperatorsSelected() {
      const n = Array.isArray(this.data_local.operators_selected)
        ? this.data_local.operators_selected.length
        : 0;

      return n > 0 && n < this.operators.length;
    },
    isEditing() {
      return !!this.guid;
    },
    tryCallsDisplay() {
      return this.data_local.try_calls + 1;
    },
    carouselsRules() {
      return [
        (v) =>
          this.data_local.outbound_mode !== 'carousels' ||
          (Array.isArray(v) && v.length > 0) ||
          'Выберите хотя бы 1 карусель',
      ];
    },
  },
  mounted() {
    this.listBases();
    this.listScripts();
    this.listDicts();
    this.listNumbers();
  },
  data() {
    return {
      saving: false,
      regions_open: false,
      regions_init_lock: false,
      operators_open: false,
      operators_init_lock: false,
      isCallMade: false,
      activeCarousels: [],
      hasActiveCarousels: false,
      carousel_init_lock: false,
      disabledSave: false,
      carouselError: false,
      operators_selected: null,
      regions_selected: null,
      targets: [],
      operators: [],
      regions: [],
      regions_enabled: false,
      operators_enabled: false,
      data_local: {
        send_call_webhook: false,
        call_webhook_method: 'POST',
        call_webhook_url: '',
        outbound_mode: 'all_active',
        outbound_carousels: [],
        try_calls: 0,
        call_webhook_body: '',
        lines_count: 1,
        use_lines_count: false,
      },
      hidedate: true,
      hidetime: true,
      timeStep: null,
      datepicker: null,
      dialog: false,
      tab: 'manual',
      webhookBodyRules: [
        (v) =>
          !this.data_local.send_call_webhook || !!v || 'Укажите тело webhook',
      ],
      rules: [
        (value) => !!value || 'Обязательное поле',
        (value) => (value || '').length <= 50 || 'Max 50 символов',
        (value) =>
          !/[\t/\\|]/.test(value) ||
          'В названии не должно присутствовать символов "/", "\\", "|", или табуляции ↹',
      ],
      linesCountRules: [
        (v) => v >= 1 || 'Минимум 1 линия',
        (v) => v <= 1000 || 'Максимум 1000 линий',
        (v) => Number.isInteger(Number(v)) || 'Должно быть целым числом',
      ],
      bases: [],
      numbers: [],
      scenaries: [],
      triggers: [{ id: 'add', name: 'Попадание номера в базу контактов' }],
      type: [
        {
          name: 'Стандартный',
          value: 'standart',
          tooltip:
            'Остановится после обзвона всех номера в выбранной базе номеров',
        },
        {
          name: 'Автоматический',
          value: 'auto',
          tooltip: 'Звонок срабатывает при активации выбранного триггера',
        },
      ],
      list_action: [
        { id: 0, name: 'Переместить в другую базу' },
        { id: 1, name: 'Интеграция с amoCRM' },
      ],
      /** Список часовых поясов  */
      listTimezoneRu: [
        { name: 'Калининград +02.00', gtm: 2 },
        { name: 'Москва +03.00', gtm: 3 },
        { name: 'Самара +04.00', gtm: 4 },
        { name: 'Екатеринбург +05.00', gtm: 5 },
        { name: 'Омск +06.00', gtm: 6 },
        { name: 'Красноярск +07.00', gtm: 7 },
        { name: 'Иркутск +08.00', gtm: 8 },
        { name: 'Якутск +09.00', gtm: 9 },
        { name: 'Владивосток +10.00', gtm: 10 },
        { name: 'Магадан +11.00', gtm: 11 },
        { name: 'Камчатка +12.00', gtm: 12 },
      ],
    };
  },
};
</script>
<style scoped>
.paste:hover {
  background: #4b5eff;
  color: white;
  transition: 0.3s;
}
.paste {
  padding: 9px 20px 10px;
  background: #ffffff;
  display: inline-block;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  margin: 12px 0 0 10px;
  cursor: pointer;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  color: #2b2d33;
}
.actions_create {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.btn_with_loader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
}

.btn_spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.invisible_text {
  opacity: 0;
}

.cancel_loader {
  border: none;
  background: transparent;
  cursor: pointer;
}

button:disabled,
.cancel_loader:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.carousel_error {
  color: #ff4d4f;
  margin-top: 12px;
  font-weight: 500;
  text-align: center;
}
.region-head {
  display: flex;
  align-items: center;
}

.regions-btn {
  display: flex;
  align-items: flex-end;
  margin-left: 15px;
  margin-bottom: 10px;
}

.close-date-picker {
  position: absolute;
  top: 9px;
  right: 9px;
}

* {
  user-select: none;
}

.my_expand_panel {
  padding: 0;
}

.my_expand_panel:before {
  box-shadow: none;
  /*border-radius: none;*/
}

.my_expand_panel .v-expansion-panel-content {
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.my_expand_panel .v-expansion-panel-header v-expansion-panel-header--active {
  padding: 0;
  min-height: initial;
}

.input_datetime {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #2b2d33;
  width: 200px;
}

.datepicker {
  position: absolute;
}

.date_time {
  display: flex;
}

.input_wrap {
  margin-right: 6px;
}

.input_wrapper {
  max-width: 65px;
}

.rel {
  position: relative;
}

.abs {
  position: absolute;
  top: 9px;
  right: 9px;
}

.heading {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 16px;
  color: #404247;
}

.input_wrapper {
  display: flex;
  align-items: center;
}

.mini_input {
  min-width: 63px;
  height: 32px;
  text-align: center;
  padding: 7px 12px;
}

.plus {
  border: 1px solid #4b5eff;
  border-radius: 8px;
  background: #fff;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  cursor: pointer;
  padding: 8px;
}

.minus {
  margin-right: 6px;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  background: #fff;
  width: 32px;
  height: 32px;
  display: flex;
  padding: 16px 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.select_type .titler {
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
  text-align: left;
  margin-bottom: 13px;
  margin-top: 16px;
}

.question {
  cursor: pointer;
}

.tooltip {
  display: flex;
  align-items: baseline;
}

.tooltip .icon {
  margin-left: 8px;
}

.add_new {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #4b5eff;
  width: max-content;
  margin-bottom: 16px;
  margin-top: 6px;
}

.add_new a {
  text-decoration: none;
}

.add_new:after {
  background: #4b5eff;
  content: '';
  display: block;
  height: 1px;
  width: 100%;
}

.rules {
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 130%;
  color: #aaabad;
  text-align: left;
  margin-bottom: 24px;
}

.cancel_btn {
  color: #4b5eff;
}
.add {
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #eee;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
}

.add_sec {
  width: 100%;
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #eee;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
}

.add .icon {
  margin-right: 11px;
}

.add_modal {
  width: 100%;
  padding: 9px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  color: #2b2d33;
}

.textarea {
  padding: 16px 0;
}

.subtitle {
  font-style: normal;
  text-align: left;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
}

.wrapper {
  padding: 32px;
}

.modal_subtitle {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  margin-bottom: 6px;
  text-align: left;
  color: #404247;
  margin-bottom: 6px;
}

.modal_title {
  padding: 0 !important;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  margin-bottom: 24px;
  text-align: center;
  line-height: 130%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2b2d33;
}

.row_wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.m-w-200p {
  min-width: 80px;
}

.w-80p {
  width: 80px;
}
.chip-truncate .v-chip__content {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.truncate-line {
  display: block;
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
